import { memo } from 'react';

import { ShareModalSectionLabel } from '~/components/ShareModal/components/ShareModalSectionLabel';
import { CreateShowcaseModalLinkDetailsFields } from '~/components/ShowcaseModal/CreateShowcaseModalLinkDetailsFields';
import { CreateShowcaseSettingsCommentsRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsCommentsRow';
import { CreateShowcaseSettingsCustomFieldsRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsCustomFieldsRow';
import { CreateShowcaseSettingsDisableExpandNestedRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsDisableExpandNestedRow';
import { CreateShowcaseSettingsDownloadsRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsDownloadsRow';
import { CreateShowcaseSettingsExpirationRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsExpirationRow';
import { CreateShowcaseSettingsHideAirLogoRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsHideAirLogoRow';
import { CreateShowcaseSettingsHideSearchBarRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsHideSearchBarRow';
import { CreateShowcaseSettingsMetadataRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsMetadataRow';
import { CreateShowcaseSettingsPasscodeRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsPasscodeRow';
import { CreateShowcaseSettingsVersionControlRow } from '~/components/ShowcaseModal/CreateShowcaseSettingsVersionControlRow';

export const CreateShowcaseModalBody = memo(() => {
  return (
    <>
      <CreateShowcaseModalLinkDetailsFields />
      <div className="flex flex-col gap-2">
        <ShareModalSectionLabel title="Versions & Downloading" />
        <CreateShowcaseSettingsVersionControlRow />
        <CreateShowcaseSettingsDownloadsRow />
      </div>
      <div className="flex flex-col gap-2">
        <ShareModalSectionLabel title="Info & comments" />
        <CreateShowcaseSettingsMetadataRow />
        <CreateShowcaseSettingsCustomFieldsRow />
        <CreateShowcaseSettingsCommentsRow />
      </div>
      <div className="flex flex-col gap-2">
        <ShareModalSectionLabel title="Visibility & permissions" />
        <CreateShowcaseSettingsHideSearchBarRow />
        <CreateShowcaseSettingsDisableExpandNestedRow />
      </div>
      <div className="flex flex-col gap-2">
        <ShareModalSectionLabel title="Security & Privacy" />
        <CreateShowcaseSettingsPasscodeRow />
        <CreateShowcaseSettingsExpirationRow />
      </div>
      <div className="flex flex-col gap-2">
        <ShareModalSectionLabel title="Branding" />
        <CreateShowcaseSettingsHideAirLogoRow />
      </div>
    </>
  );
});

CreateShowcaseModalBody.displayName = 'CreateShowcaseModalBody';
